var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', [_c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    },
    model: {
      value: _vm.isValid,
      callback: function ($$v) {
        _vm.isValid = $$v;
      },
      expression: "isValid"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 my-2"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-account")]), _vm._v(" Contact Information")], 1)]), _vm._l(_vm.textInputs, function (textInput) {
    return _c('v-col', {
      key: textInput.key,
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": textInput.label,
        "outlined": "",
        "required": textInput.required,
        "rules": _vm.validationRules[textInput.key],
        "type": textInput.type
      },
      model: {
        value: _vm.formData.info[textInput.key],
        callback: function ($$v) {
          _vm.$set(_vm.formData.info, textInput.key, $$v);
        },
        expression: "formData.info[textInput.key]"
      }
    })], 1);
  }), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-multimedia")]), _vm._v("Preferred Formats")], 1)]), _vm._l(_vm.mediaFormats, function (checkbox) {
    return _c('v-col', {
      key: checkbox.value,
      staticClass: "d-flex flex-column align-start justify-start px-4 py-1 py-md-2",
      attrs: {
        "cols": "12",
        "sm": "4"
      }
    }, [_c('v-checkbox', {
      staticClass: "ma-0",
      attrs: {
        "label": checkbox.label,
        "value": checkbox.value,
        "hide-details": ""
      },
      model: {
        value: _vm.formData.formats,
        callback: function ($$v) {
          _vm.$set(_vm.formData, "formats", $$v);
        },
        expression: "formData.formats"
      }
    })], 1);
  }), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-star")]), _vm._v("Genre Interests")], 1), _vm._l(_vm.genreInterests, function (genreInterest) {
    return [_c('v-sheet', {
      key: genreInterest.key,
      staticClass: "d-flex flex-column flex-sm-row align-start align-sm-center justify-space-between py-4 py-sm-2"
    }, [_c('p', {
      staticClass: "font-weight-bold primary--text pa-0 ma-0"
    }, [_vm._v(_vm._s(genreInterest.label))]), _c('v-radio-group', {
      staticClass: "mt-0 text-no-wrap",
      attrs: {
        "dense": "",
        "hide-details": "",
        "row": ""
      },
      model: {
        value: _vm.formData.genres[genreInterest.key],
        callback: function ($$v) {
          _vm.$set(_vm.formData.genres, genreInterest.key, $$v);
        },
        expression: "formData.genres[genreInterest.key]"
      }
    }, [_c('v-radio', {
      attrs: {
        "label": "low",
        "value": "-1"
      }
    }), _c('v-radio', {
      attrs: {
        "label": "neutral",
        "value": "0"
      }
    }), _c('v-radio', {
      attrs: {
        "label": "high",
        "value": "1"
      }
    })], 1)], 1), _c('v-divider', {
      key: genreInterest.key + 'd'
    })];
  })], 2), _c('v-col', {
    staticClass: "d-flex flex-column align-start justify-start",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-book-heart")]), _vm._v("Favorite Titles and Authors ")], 1), _c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "auto-grow": "",
      "full-width": "",
      "hide-details": "",
      "outlined": "",
      "rows": "4"
    },
    model: {
      value: _vm.formData.questions.favorites,
      callback: function ($$v) {
        _vm.$set(_vm.formData.questions, "favorites", $$v);
      },
      expression: "formData.questions.favorites"
    }
  })], 1), _c('v-col', {
    staticClass: "d-flex flex-column align-start justify-start",
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('p', {
    staticClass: "d-flex align-center font-weight-bold primary--text text-h6 text-no-wrap mb-2 mt-8"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "primary"
    }
  }, [_vm._v("mdi-book-clock")]), _vm._v("Last Enjoyed Books ")], 1), _c('v-textarea', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "auto-grow": "",
      "full-width": "",
      "hide-details": "",
      "outlined": "",
      "rows": "4"
    },
    model: {
      value: _vm.formData.questions.last_enjoyed,
      callback: function ($$v) {
        _vm.$set(_vm.formData.questions, "last_enjoyed", $$v);
      },
      expression: "formData.questions.last_enjoyed"
    }
  })], 1), _c('v-col', {
    staticClass: "my-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-sheet', {
    attrs: {
      "min-height": "75",
      "width": "100%"
    }
  }, [_c('v-alert', {
    attrs: {
      "value": !!_vm.error,
      "type": "error"
    }
  }, [_vm._v(" " + _vm._s(_vm.error) + " ")])], 1)], 1), _c('v-col', {
    staticClass: "px-4 mt-8",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    staticClass: "submit-btn mx-auto",
    attrs: {
      "block": "",
      "color": "primary",
      "loading": _vm.isLoading,
      "type": "submit"
    }
  }, [_vm._v("SUBMIT")])], 1)], 2)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }